import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
    detailsContainer: {
        padding: theme.spacing(4)
    }
});

type ContainerProps = WithStyles<"detailsContainer">

const DetailsContainer: React.SFC<ContainerProps> = (props) => {
    return (
        <Paper style={{ padding: 8 }}>
            <Grid container spacing={2} className={props.classes.detailsContainer}>
                {props.children}
            </Grid>
        </Paper>
    );
}

export default withStyles(styles)(DetailsContainer);


// WEBPACK FOOTER //
// ./src/components/tables/DetailsContainer.tsx